// extracted by mini-css-extract-plugin
export default {"hr":"Footer_hr__hq4d-","container_footer":"Footer_container_footer__YcpTY","lastfooter":"Footer_lastfooter__lfV6d"};